import React, {useEffect, useState} from 'react';
import ReactTable from "components/ReactTable/ReactTablebep.js";
// reactstrap components
import {
   Card,
  CardBody,Button,Modal, ModalHeader, ModalBody,Input,
  Row,
    Col,

  } from "reactstrap";

function Users(props) {
    const [showProcessing, setShowProcessing] = useState(false)
    const [users, setUsers] = useState([])
    const [skippy, setSkippy] = useState(0)
    const [limit, setLimit] = useState(10)
    const [total, setTotal] = useState(500)
    const [pageNumber, setPageNumber] = useState(1) 
    
    const [fusersh, setFusersh] = useState(false)
    const [fuser, setFuser] = useState("")

   

    const nextpage = () => {
      let page = pageNumber === 0 ?  1  : pageNumber;
      if(Math.ceil(total/limit) >= pageNumber + 1){
          
          setPageNumber(pageNumber + 1)
          page = pageNumber + 1 
      }else{
          
          page = pageNumber
          
      }
      let npage = page -1 
      let tskip = pageNumber === 0 ?  0 : npage  * limit        
      
      fetchdatap(tskip, limit)
      
      
  }
  const previouspage = () => {
    let page = pageNumber === 0 ?  0  : pageNumber -1 ;
    if(page <= 0){
        
        setPageNumber(0)
        fetchdatap(0, limit)
    }else{
        
        page = pageNumber -1 
        let tskip = page  * limit      
        setPageNumber(page)  
        fetchdatap(tskip, limit)
    }
  }
  
    useEffect(() => {
        fetchdata()
    },[])


    const fetchdata = () => {
      
        setShowProcessing(true)
            props.API.get(`tenant/fetchusers/${skippy}/${limit}`,
                 { headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                  setShowProcessing(false)
                  
                setUsers(res.data.data.map(x => {
                    return ({...x, actions : (
                        <div style={{textAlign : "center"}}>
                            <i className="fa fa-bell fa-2xs" style={{cursor : "pointer"}} onClick={t => {cangep(x)}}></i>
                            <i className="fa fa fa-key fa-2xs" style={{cursor : "pointer", paddingLeft : 30}} onClick={t => {cangep(x)}}></i>     
                        </div>
                    )})
                }))
                setSkippy(res.data.page)
                setTotal(res.data.total)
              
            }).catch(function (error) {
                setShowProcessing(false)
                
                  if(error.response.status === 401){
                    props.swal("Unauthorized, please login again.").then(t => {
                        props.history.push(`/auth/login`)
                    })   
                  }else{
                      props.swal("Error fetching request data")
                  }
                
            }) 
    }

    const fetchdatap = (pn, limit) => {
        setShowProcessing(true)
      
            props.API.get(`tenant/fetchusers/${pn}/${limit}`,
                 { headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            //  props.basicAlert(res.data.message)
     
                setUsers(res.data.data.map(x => {
                    return ({...x, actions : (
                        <div style={{textAlign : "center"}}>
                          <i className="fa fa-bell fa-2xs" style={{cursor : "pointer"}} onClick={t => {cangep(x)}}></i>
                          <i className="fa fa fa-key fa-2xs" style={{cursor : "pointer", paddingLeft : 30}} onClick={t => {cangep(x)}}></i>    
                          </div>
                    )})
                }))
              
            }).catch(function (error) {
                setShowProcessing(false)
                console.log(error)
                if(error.response.status === 401){
                  props.swal("Unauthorized, please login again.").then(t => {
                      props.history.push(`/auth/login`)
                  })   
                }else{
                    props.swal("Error fetching request data")
                }
             
            }) 
    }

// Reset Password
    const cangep = (f) => {
  
  setShowProcessing(true)
  props.API.post(`tenant/rnmcpux`, {guid : f.personalEmail},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
     props.swal(res.data.message)
      setShowProcessing(false)
      
    }).catch(function (error) {
      setShowProcessing(false)
       console.log(error)
       if(error.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
        }else{
            props.swal("Error fetching request data")
        }
    })      
}

    const findunser = (id) => {
            
            setShowProcessing(true)
                props.API.get(`tenant/fetchusers/${id}`,
                     { headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                //  props.basicAlert(res.data.message)
                    setShowProcessing(false)
                      
                    setUsers(res.data.data.map(x => {
                        return ({...x, actions : (
                            <div style={{textAlign : "center"}}>
                              <i className="fa fa-bell fa-2xs" style={{cursor : "pointer"}} onClick={t => {cangep(x)}}></i>
                              <i className="fa fa fa-key fa-2xs" style={{cursor : "pointer", paddingLeft : 30}} onClick={t => {cangep(x)}}></i>    
                            </div>
                        )})
                    }))
                    setSkippy(res.data.page)
                    setTotal(res.data.total)
                    if(res.data.data.length >= 1){
                      setFusersh(false)
                    }
                    
                }).catch(function (error) {
                    setShowProcessing(false)
                    console.log(error)
                    if(error.response.status === 401){
                      props.swal("Unauthorized, please login again.").then(t => {
                          props.history.push(`/auth/login`)
                      })   
                    }else{
                        props.swal("Error fetching request data")
                    }
                  //  props.basicAlert("Error fetching tenant by ID")
                }) 
        
    
    }

    const fusermodal = () => {
        return (
            <Modal isOpen = {fusersh}>
                <ModalHeader toggle={t => {setFusersh(!fusersh);setFuser("")}}></ModalHeader>
                <ModalBody>
                    <Row>

                        <Col md="8"><label>Find GUID</label>   <Input type="text" value={fuser} onChange={f => setFuser(f.target.value)} /></Col>
                        <Col><Button style={{marginTop : 30}} size="sm" onClick={i => findunser(fuser)}>Find</Button></Col>
                    </Row>
                 
                    
                </ModalBody>
            </Modal>
        )
    }

    return (
        <div className="content">
            {fusermodal()}
        <Row>
          <Col md="12">
            <Card>

              <CardBody>
                <Row style={{marginBottom : 10}}><Col>  <i className="fa fa-search" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={f => setFusersh(true)}></i></Col></Row>
                <ReactTable
                 totalpages = {Math.floor(total/limit)}
                 pagenumber = {pageNumber}
                 pagesize = {limit}
                  data= {users}
                  nextpage = {nextpage}
                  previouspage={previouspage}
                  pageNumber = {pageNumber}
                  setPageNumber={setPageNumber}
                  setLimit={setLimit}
                  limit={limit}
                  columns={[
                    {
                        Header: "GUID",
                        accessor: d => d.guid,
                      },               
                    {
                      Header: "Email",
                      accessor: d => d.personalEmail,
                    },
                    {
                        Header: "Name",
                        accessor: d => d.displayName,
                      },
                      {
                        Header: "cell",
                        accessor: d => d.cell,
                      },
                      {
                        Header: "D.O.B",
                        accessor: d => new Date(d.dob).toLocaleDateString(),
                      },
                      /**   
                      {
                        Header: "Lat long",
                        accessor: d => d.latlonginfo,
                      },
                      {
                        Header: "Last Access",
                        accessor: d => new Date(d.lastAccessTime).toLocaleDateString(),
                      },
                      */
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  /*
                      You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                    */
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
}

export default Users;